<template>
  <div id="AlterarSenha">
    <el-dialog
      title="Alterar Senha"
      :visible.sync="visible"
      width="350px"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
      >
        <el-form-item
          label="Nova Senha"
          prop="senha"
          class="form-group"
        >
          <div class="el-input el-input--small">
            <input
              @keypress.enter="handleSubmit()"
              v-model.lazy="form.senha"
              type="password"
              class="el-input__inner"
            >
          </div>
        </el-form-item>
        <el-form-item
          label="Confirma Senha"
          prop="confirmaSenha"
          class="form-group"
        >
          <div class="el-input el-input--small">
            <input
              @keypress.enter="handleSubmit()"
              v-model.lazy="form.confirmaSenha"
              type="password"
              class="el-input__inner"
            >
          </div>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
        style="margin-top: 0; padding-top: 0"
      >
        <a
          class="btn branco esquerda"
          @click="handleClose()"
        >Fechar</a>
        <a
          v-loading="loading"
          class="btn branco direita"
          type="primary"
          @click="handleSubmit()"
        >Salvar</a>
        <div style="clear: both" />
      </span>
    </el-dialog>
  </div>
</template>

<script>
import services from '@/services'
import { mapGetters } from 'vuex'

export default {
  name: 'AlterarSenha',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'))
      } else {
        if (this.form.confirmaSenha !== '') {
          this.$refs.form.validateField('confirmaSenha')
        }
        callback()
      }
    }

    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'))
      } else if (value !== this.form.senha) {
        callback(new Error('Os campos não conferem'))
      } else {
        callback()
      }
    }
    return {
      form: {
        id: null,
        senha: '',
        confirmaSenha: '',
      },
      rules: {
        senha: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        confirmaSenha: [
          { required: true, message: 'Campo obrigatório', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' },
        ],
      },
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      getUsuario: 'getUsuario',
    }),
  },
  methods: {
    handleClose() {
      this.$emit('visible', false)
    },
    async handleSubmit() {
      this.loading = true

      try {
        this.$refs.form.validate((valid) => {
          if (!valid) throw new Error('Existem erros no formulário, corríja-os antes de prosseguir.')
        })

        let response = await services.Auth.change(this.form)

        if (response) {
          this.$notify.success({ title: 'Parabéns', message: 'Formulário salvo com sucesso', offset: 100 })
          this.handleClose()
        }
      } catch (e) {
        this.$notify.error({
          title: 'Atenção!',
          message: 'Erro ao salvar o formulário. Motivo: ' + e.message,
          offset: 100,
          duration: 0,
        })
      }

      this.loading = false
    },
  },
}
</script>

<style>
#AlterarSenha .el-dialog__body {
  padding: 30px 20px 0 20px !important;
}
#AlterarSenha label.el-form-item__label {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 0px;
}
#AlterarSenha .el-form-item__error {
  padding-top: 0;
  font-size: 10px;
}
#AlterarSenha .el-dialog__header {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/AlterarSenha.vue